import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireSuperAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone-100">
        <div className="text-forest-600 text-sm tracking-[0.2em] uppercase">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (requireSuperAdmin && !user.is_super_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Force users through onboarding before they can hit the dashboard
  // (super admins skip onboarding entirely)
  if (
    !user.is_super_admin &&
    !user.onboarding_completed &&
    !location.pathname.startsWith("/onboarding")
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
